export default __webpack_public_path__ + "static/media/Auth.00d5bd86.svg";